const AgentInterestDropDown=[
    {value:1,label:'All'},
    {value:2,label:'Property'},
    {value:3,label:'Vehicle'},
]

export {AgentInterestDropDown}